import { render, staticRenderFns } from "./SalesDepartmentsSelect.vue?vue&type=template&id=341cb6f0&"
import script from "./SalesDepartmentsSelect.vue?vue&type=script&lang=ts&"
export * from "./SalesDepartmentsSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports